import React from 'react';
import { useFormContext } from 'react-hook-form';
import cx from 'classnames';

import { getAutofillString, getErrorMessage } from '../utils';
import FieldWrapper from './FieldWrapper';

import { select, selectFixed } from '../styles.module.css';

export const BaseSelect = ({
  id,
  nullOptionLabel = '- Choose an option -',
  required,
  validation,
  options,
  optionLabels,
  title = 'Selection',
  disabled,
  className,
  fixed,
  value,
}) => {
  const { register } = useFormContext();

  return (
    <select
      id={id}
      name={id}
      disabled={disabled}
      autoComplete={getAutofillString(id)}
      defaultValue={value ?? ''}
      className={cx(className, select, fixed && selectFixed)}
      ref={register({
        required: required && `${title} required`,
        ...validation,
      })}
    >
      {nullOptionLabel ? <option value="">{nullOptionLabel}</option> : null}
      {options.map((option, i) => (
        <option key={option} value={option}>
          {optionLabels?.[i] || option}
        </option>
      ))}
    </select>
  );
};

export const GroupSelect = (props) => {
  const { errors } = useFormContext();
  const { id: groupId, subFields, disabled, error, ...rest } = props;
  const groupRequired = subFields.some(({ required }) => required);
  const individalErrorMessages = subFields
    .map((subField) =>
      getErrorMessage({
        ...subField,
        errors: errors?.[groupId] || {},
      }),
    )
    .filter((i) => i)
    .join(', ');

  return (
    <FieldWrapper
      required={groupRequired}
      error={individalErrorMessages || error}
      disabled={disabled}
      {...rest}
    >
      {subFields.map((subProps) => {
        const { id, ...restProps } = subProps;
        const subId = `${groupId}.${id}`;

        return (
          <BaseSelect
            key={subId}
            disabled={disabled}
            id={subId}
            nullOptionLabel={restProps.nullOptionLabel || restProps.title}
            {...restProps}
          />
        );
      })}
    </FieldWrapper>
  );
};

const Select = (props) => {
  return (
    <FieldWrapper {...props}>
      <BaseSelect {...props} />
    </FieldWrapper>
  );
};

export default Select;
